import { EntityId } from 'entities-next/common'
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'

import { User } from '../../entities-next/user'

export const fetchCurrentUser = createAsyncAction(
  '/data/auth/CURRENT_USER_FETCH_BEGIN',
  '/data/auth/CURRENT_USER_FETCH_SUCCESS',
  '/data/auth/CURRENT_USER_FETCH_FAILURE'
)<EntityId, User, Error>()

export const logoutBegin = createAction('/scenes/Login/LOGOUT_BEGIN')
export const logoutSuccess = createAction('/scenes/Login/LOGOUT_SUCCESS')

export type AuthAction = ActionType<typeof logoutBegin | typeof logoutSuccess | typeof fetchCurrentUser>
